import React from "react";
import { bool, func, number } from "prop-types";
import { Row, Col } from "react-bootstrap";
import Toggle from "react-toggle";
import "react-toggle/style.css";

const ReuseResultsSetting = ({
  handleChangeReuseResults,
  months,
  reuseCandidateResults,
}) => (
  <Row>
    <Col lg={10} md={10} sm={10}>
      <h4 className="mb-3">Reuse Results</h4>
      <p>
        Automatically reuse previous test results taken within the last{" "}
        {months || 12} months for these selected events if a candidate is
        invited to take a test that they have taken recently for your
        organization.
      </p>
    </Col>
    <Col lg={2} md={2} sm={2} className="text-right">
      <div style={{ margin: "auto" }}>
        <Toggle
          icons={false}
          id="reuse-results"
          className="global-toggle"
          checked={reuseCandidateResults}
          onChange={handleChangeReuseResults}
        />
      </div>
    </Col>
  </Row>
);

ReuseResultsSetting.propTypes = {
  handleChangeReuseResults: func.isRequired,
  months: number,
  reuseCandidateResults: bool,
};

export default ReuseResultsSetting;
